import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import { AuthProvider } from "./context/AuthContext";
import AndroidDownloadPage from "./pages/AndroidDownloadPage";
import IOSUnsupportedPage from "./pages/IOSUnsupportedPage";
import { isNativeMobileShell } from "./native/mobileBridge";
import isIOSBrowser from "./native/isIOSBrowser";

const query = new URLSearchParams(window.location.search);
const isAndroidBrowser = /Android/i.test(window.navigator.userAgent);
const isMobileDevHost = window.location.hostname === "mobiledev.plutonichealth.co";
const isRootPage = window.location.pathname === "/";
const showAndroidDownload =
  !isNativeMobileShell() &&
  isRootPage &&
  ((isMobileDevHost && isAndroidBrowser) || query.get("androidDownloadPreview") === "1");
const showIOSUnsupported = !isNativeMobileShell() && isIOSBrowser();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {showIOSUnsupported ? (
      <IOSUnsupportedPage />
    ) : showAndroidDownload ? (
      <AndroidDownloadPage />
    ) : (
      <AuthProvider> {/* ✅ Add AuthProvider here */}
        <Router>
          <App />
        </Router>
      </AuthProvider>
    )}
  </React.StrictMode>
);



// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
